import { Info } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Text,
} from "@musa.tech/design-system";

export function TaxChangeNoticeAccordion() {
  return (
    <Accordion type="single" collapsible defaultValue="tax-notice">
      <AccordionItem value="tax-notice" className="border-0">
        <div className="bg-warning-100 border border-warning-200 rounded-lg overflow-hidden">
          <AccordionTrigger className="px-4 py-3 hover:no-underline">
            <div className="flex items-center gap-3">
              <div className="p-1.5 bg-warning-200 rounded-md flex-shrink-0">
                <Info className="h-4 w-4 text-warning-600" />
              </div>
              <Text variant="label" size="small" className="text-warning-900">
                Alteração na nota fiscal — Prefeitura de SP
              </Text>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pt-0">
            <Text variant="body" size="small" className="text-neutral-600 leading-relaxed ml-10">
              A Prefeitura de São Paulo mudou a forma como os impostos aparecem na nota fiscal. Desde 14/05/2026, os campos PIS/PASEP e COFINS mostram tributos da Musa Tecnologia — não são valores descontados do seu pagamento. O total da sua fatura não foi alterado.
            </Text>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
